"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKey = void 0;
/**
 * Generates a unique key by combining a numeric index and a string identifier.
 */
const getKey = (id, index) => `${index}-${id}`;
exports.getKey = getKey;
